/**
 * @generated SignedSource<<4002c846695d42fce1ec8760154f6d30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ServicePeriodSource = "BILLING_CYCLE" | "FASTBILL" | "MANUAL" | "%future added value";
export type ServicePeriodStatus = "CONFIRMED" | "PROPOSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ExpenseInvoiceServicePeriod_invoice$data = {
  readonly id: string;
  readonly invoiceDate: any;
  readonly servicePeriodEnd: any | null | undefined;
  readonly servicePeriodSource: ServicePeriodSource | null | undefined;
  readonly servicePeriodStart: any | null | undefined;
  readonly servicePeriodStatus: ServicePeriodStatus | null | undefined;
  readonly " $fragmentType": "ExpenseInvoiceServicePeriod_invoice";
};
export type ExpenseInvoiceServicePeriod_invoice$key = {
  readonly " $data"?: ExpenseInvoiceServicePeriod_invoice$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExpenseInvoiceServicePeriod_invoice">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExpenseInvoiceServicePeriod_invoice",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiceDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "servicePeriodStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "servicePeriodEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "servicePeriodSource",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "servicePeriodStatus",
      "storageKey": null
    }
  ],
  "type": "ExpenseInvoice",
  "abstractKey": null
};

(node as any).hash = "bd06735f3a2b05f9d3800e0fd5a5e71c";

export default node;
